import React, { Component } from 'react';
import { Graphic, Message, When, Where, Signature, RSVPPublic } from '../host/preview'
import { Row } from '../generic'
import checkRequiredFields, { validString, validRadio, validEmail } from '../../helpers/check-required-fields';
import { hashToUri } from '../../helpers/util';
import * as variables from '../../styles/variables';
import styled from 'styled-components';

const Column = styled.div`
  max-width: 700px;
  padding: 10px 10px 0px;
  @media screen and (min-width: 600px) {
    padding: 32px 10px 50px;
  }
  width: 100%;
  margin: 0 auto;
  background: white;
`

const WideColumn = styled.div`
  max-width: 1100px;
  background: white;
  margin: 0 auto;
`

const LetterContainer = styled.div`
  padding: 10px 10px 10px;
  // background-color: ${variables.colours.lightGrey};
  margin-bottom: 25px;
  &.cancelled {
    opacity: 0.5;
  }
`

const NotFound = styled.div`
  background-color: ${variables.colours.lightGrey}
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 0 20px;
  div {
    text-align: center;
    max-width: 500px;
    width: 100%;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 2px 2px 30px rgba(0,0,0,0.4);
  }
  h1 {
    margin-top: 0px;
  }
  p {
    margin-bottom: 0;
  }
`

const Warning = styled.div`
  background-color: ${variables.colours.orange}
  color: white;
  padding: 15px 10px;
  border-radius: 10px;
  margin-top: 32px;
  text-align: center;
  font-size: 22px;
  margin-top: -20px;
  margin-bottom: 20px;
`

const HorizontalDivider = styled.hr`
  border: 0;
  height: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  margin: -20px 0 20px;
  @media screen and (min-width: 600px) {
    margin: 30px 0;
  }
`

class Register extends Component {

  constructor(props) {
    super(props);
    this.state = {
      guest: {
        status: null,
        first_name: '',
        last_name: '',
        email: '',
        message: '',
      },
      valid: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.props.getEvent(this.props.match.params.token)
  }

  handleChange(e) {
    // handle attribute change on user or event
    // reads nested input name: i.e. "objectType[attribute]", e.g. "currentUser[firstname]"
    const matches = e.target.name.match(/(.*)\[(.*)\]/)
    let objectType = matches[1]
    let attribute = matches[2]
    let nextState = {
      [objectType]: {
        ...this.state[objectType],
        [attribute]: e.target.value
      },
    }
    nextState.valid = checkRequiredFields([
      'status',
      'first_name',
      'last_name',
      (guest) => {
        return validRadio(guest.status, 'yes') && !validEmail(guest.email) ? false : true
      },
    ], nextState.guest)
    this.setState(nextState)
  }

  handleSubmit(e, previousPath) {
    this.props.createGuest(this.props.userEvent, this.state.guest)
    e.preventDefault()
  }

  render() {
    const { userEvent, isLoading, eventError } = this.props

    if (userEvent) {
      document.title = `Invitation to ${userEvent.topic} - On the Table BC`

      let el = document.querySelector('meta[property="og:image"]')
      if (!el) {
        el = document.createElement("META")
        el.setAttribute('property', 'og:image')
        document.head.appendChild(el)
      }
      const params = {
        food1: userEvent.food1 || '',
        food2: userEvent.food2 || '',
        topic: userEvent.topic || '',
        image: userEvent.invitation_logo || '',
      }
      el.setAttribute('content', `${process.env.REACT_APP_BASE_URL}/api/image?${hashToUri(params)}`)
    }

    return (
      <div style={{background: "#eee", display: 'flex'}}>
        {isLoading && (<div>Loading...</div>)}
        {eventError && (
          <NotFound>
            <div>
              <h1>Event Not Found</h1>
              <p>Please contact your host to see if they can help.</p>
            </div>
          </NotFound>
        )}
        {userEvent && (
          <WideColumn>
            {/* TODO: rename the 'public' prop to 'hostPreview' and pass false here. */}
            <Graphic public={true} userEvent={userEvent}/>
            <Column>
              {userEvent && userEvent.cancelled && <Warning>This event is cancelled.</Warning>}
              <LetterContainer className={userEvent && userEvent.cancelled ? 'cancelled' : ''}>
                <Message public={true} userEvent={userEvent}/>
                <Row style={{marginBottom: '20px'}} className="twoCol">
                  <div>
                    <When public={true} userEvent={userEvent}/>
                  </div>
                  <div>
                    <Where public={true} userEvent={userEvent}/>
                  </div>
                </Row>
                {userEvent && !userEvent.cancelled && [448].indexOf(userEvent.id) === -1 && <RSVPPublic userEvent={userEvent} guest={this.state.guest} onChange={this.handleChange} onSubmit={this.handleSubmit} valid={this.state.valid} loading={this.props.guestLoading} sent={this.props.guests && this.props.guests.length > 0} />}
                {[448].indexOf(userEvent.id) > -1 &&  (
                  <React.Fragment>
                    <HorizontalDivider/>
                    <h2>Sorry, registration for this event is full.</h2>
                  </React.Fragment>
                )}
              </LetterContainer>
            </Column>
          </WideColumn>
        )}
      </div>
    )
  }
}

export default Register
